<template>
    <div
        v-if="showPicker"
        class="kgr-grid kgr-grid--full kgr-grid--small-fit kgr-grid--gutters kgr-grid--bigGutters"
    >
        <div class="kgr-grid__cell">
            <div class=" kgr-inputGroup">
                <div
                    v-t="'Freigabe für Abteilungen'"
                    class="kgr-inputGroup__label"
                ></div>
                <p
                    v-if="!departmentsAvailable"
                    v-t="'Keine Abteilungen vorhanden.'"
                ></p>
                <kgr-multi-select
                    v-else
                    v-model="selectedDepartments"
                    :options="flattenDepartments"
                    display="name"
                    searchable
                    :disabled="!clearingEditable"
                    @post-input="selectedDepartmentsChange()"
                />
            </div>
        </div>

        <div
            class="kgr-grid__cell"
        >
            <div class=" kgr-inputGroup">
                <div
                    v-t="'Freigabe für Teams'"
                    class="kgr-inputGroup__label"
                ></div>
                <p
                    v-if="!teamsAvailable"
                    v-t="'Keine Teams vorhanden.'"
                ></p>
                <kgr-multi-select
                    v-else
                    v-model="selectedTeams"
                    :options="fullTeamsList"
                    display="name"
                    searchable
                    :disabled="!clearingEditable"
                    @post-input="selectedTeamsChange($event)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import MultiSelect from '../../common/form/select/MultiSelect.vue';

export default {
    components: {
        'kgr-multi-select': MultiSelect,
    },
    props: {
        clearingFormId: {
            type: String,
            required: true,
        },
        clearingDepartmentsId: {
            type: String,
            required: true,
        },
        clearingTeamsId: {
            type: String,
            required: true,
        },
        clearingMembers: {
            type: String,
            required: true,
        },
        clearingEmployees: {
            type: String,
            required: true,
        },
        departments: {
            type: Array,
            required: true
        },
        teams: {
            type: Array,
            required: true
        },
        clearingEditable: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    data() {
        return {
            showPicker: false,
            flattenDepartments: [],
            sortedTeams: [],
            selectedDepartments: [],
            selectedTeams: [],
        }
    },
    computed: {
        departmentsAvailable() {
            return this.flattenDepartments.length !== 0;
        },
        teamsAvailable() {
            return this.teams.length !== 0;
        },
        fullTeamsList() {
            return this.filteredTeams
                .map((t) => {
                    return {
                        id: t.id,
                        name: t.departmentName + ' / ' + t.name
                    }
                })

        },
        filteredTeams() {
            return this.sortedTeams
                .filter(t => t.isBasicDataEditable)
                .filter(t => this.selectedTeams.indexOf(t) === -1);
        },
        filteredDepartments() {
            return this.departments
                .filter(d => d.isEditable)
                .filter(d => this.selectedDepartments.indexOf(d) === -1);
        }
    },
    mounted() {
        this.flattenDepartmentsAndChildDepartments(this.filteredDepartments);
        this.markSelectedDepartmentsAndTeams();
        this.checkShowPicker();
        this.sortTeams(this.teams);

        const clearingInputs = this.jQuery_clearingInputs();
        if (clearingInputs) {
            clearingInputs.change(this.checkShowPicker);
            this.$once('hook:destroyed', () => clearingInputs.off('change', this.checkShowPicker));
        }
    },
    methods: {
        sortTeams(teams) {
            this.sortedTeams = teams.sort((a, b) => (a.departmentName + ' / ' + a.name).toLowerCase().localeCompare((b.departmentName + ' / ' + b.name).toLowerCase()));
        },
        checkShowPicker() {
            const clearingInput = this.jQuery_clearingInput();
            if (clearingInput && (clearingInput.val() === this.clearingMembers || clearingInput.val() === this.clearingEmployees)) {
                this.showPicker = true;
            } else {
                this.showPicker = false;
                this.deselectDepartmentsAndTeams();
            }
        },
        flattenDepartmentsAndChildDepartments(departments) {
            departments.sort((a, b) => (a.departmentName + ' / ' + a.name).toLowerCase().localeCompare((b.departmentName + ' / ' + b.name).toLowerCase()));
            departments.forEach(department => {
                this.flattenDepartments.push({
                    id: department.id,
                    name: department.name
                });
                this.getChildDepartments(department);
            });
        },
        getChildDepartments(department) {
            department.childDepartments.sort((a, b) => ((a.name).toLowerCase() < (b.name).toLowerCase()) ? -1 : ((a.name).toLowerCase() > (b.name).toLowerCase()) ? 1 : 0);
            department.childDepartments.forEach(childDepartment => {
                this.flattenDepartments.push({
                    id: childDepartment.id,
                    name: childDepartment.hierarchyPath + ' / ' + childDepartment.name
                });
                this.getChildDepartments(childDepartment);
            });
        },
        selectedDepartmentsChange() {
            this.jQuery_departmentOptions().removeAttr('selected');
            this.selectedDepartments.forEach((department) => {
                const departmentOption = this.jQuery_departmentOption(department.id);
                if (departmentOption) {
                    departmentOption.attr('selected', true);
                }
            });
        },
        selectedTeamsChange() {
            this.jQuery_teamOptions().removeAttr('selected');
            this.selectedTeams.forEach((team) => {
                const teamOption = this.jQuery_teamOption(team.id);
                if (teamOption) {
                    teamOption.attr('selected', true);
                }

            });
        },
        markSelectedDepartmentsAndTeams() {
            this.selectedDepartments = [];
            this.selectedTeams = [];

            this.jQuery_departmentOptionSelected().each((_, option) => {
                const department = this.flattenDepartments.find(availableDepartment => '' + availableDepartment.id === $(option).val());
                if (department) {
                    this.selectedDepartments.push(department);
                }
            });

            this.jQuery_teamOptionSelected().each((_, option) => {
                const team = this.teams.find(availableTeam => '' + availableTeam.id === $(option).val());
                if (team) {
                    this.selectedTeams.push(team);
                }
            });
        },
        deselectDepartmentsAndTeams() {
            this.jQuery_departmentOptions().removeAttr('selected');
            this.jQuery_teamOptions().removeAttr('selected');
            this.markSelectedDepartmentsAndTeams();
        },
        jQuery_departmentOptions() {
            return this.jQuery_options(this.jQuery_departmentsSelect());
        },
        jQuery_departmentOption(value) {
            return this.jQuery_option(value, this.jQuery_departmentsSelect());
        },
        jQuery_departmentOptionSelected() {
            return this.jQuery_optionSelected(this.jQuery_departmentsSelect());
        },
        jQuery_teamOptions() {
            return this.jQuery_options(this.jQuery_teamsSelect());
        },
        jQuery_teamOption(value) {
            return this.jQuery_option(value, this.jQuery_teamsSelect());
        },
        jQuery_teamOptionSelected() {
            return this.jQuery_optionSelected(this.jQuery_teamsSelect());
        },
        jQuery_optionSelected(select) {
            return select.children('option:selected');
        },
        jQuery_option(value, select) {
            return select.children(`option[value="${value}"]`);
        },
        jQuery_options(select) {
            return select.children('option');
        },
        jQuery_departmentsSelect: function () {
            return $(`#${this.clearingDepartmentsId}`);
        },
        jQuery_teamsSelect: function () {
            return $(`#${this.clearingTeamsId}`);
        },
        jQuery_clearingInput() {
            return $(`#${this.clearingFormId} input[type=radio]:checked`);
        },
        jQuery_clearingInputs() {
            return $(`#${this.clearingFormId} input[type=radio]`);
        },
    }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
